import { useCallback, useEffect, useState } from "react";
import { DeleteProductSkuById, GetColorType, GetProductSkuByProductId, GetShapeType, GetSizeType, getTexType, GetWeightType, SaveProductSku } from "../../../../_services";
import toast from "react-hot-toast";
import { Toaster } from "react-hot-toast";
import DataTable from 'react-data-table-component';
import { imageurl, projectNo } from "../../../../_config";
import { resizeImage } from "../../../../_services/resizeImage";

const ProductSku = (props) => {
    const { bulkPopupClose, setBulkPopupSkuId, bulkPopupSkuId, productId, setImageSkuId, setBulkImageFormData, onBulkUpload } = props;
    const [loading, setLoading] = useState(false);
    const [colors, setColors] = useState([]);
    const [isFormopen, setIsFormopen] = useState(false);
    const [skuId, setSkuId] = useState(null);
    const [texType, setTexType] = useState([]);
    const [sizeType, setSizeType] = useState([]);
    const [shapeType, setShapeType] = useState([]);
    const [weightType, setWeightType] = useState([]);
    const [productSkuByProductId, setProductSkuByProductId] = useState([]);
    const [filteredData, setFilteredData] = useState(productSkuByProductId);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedSize, setSelectedSize] = useState('All');
    const SelectedColor = sessionStorage.getItem('SelectedColor');
    // const [selectedColor, setSelectedColor] = useState(SelectedColor ? SelectedColor : 'All');
    const [selectedColor, setSelectedColor] = useState('All');

    const [formData, setFormData] = useState({
        shapeId: 0,
        weightId: 0,
        buyPrice: 0,
        taxId: 0,
        salePrice: 0,
        mrp: 0,
        skuId: 0,
        skucode: '',
        productId: productId,
        sizeTypeId: 0,
        colorId: 0,
        isActive: true,
        createdBy: 0
    });

    const onClose = () => {
        setSkuId(0);
        handleReset();
        setIsFormopen(false);
    };

    const handleReset = () => {
        setFormData({
            shapeId: 0,
            weightId: 0,
            buyPrice: 0,
            taxId: 0,
            salePrice: 0,
            mrp: 0,
            skuId: 0,
            skucode: '',
            productId: productId,
            sizeTypeId: 0,
            colorId: 0,
            isActive: true,
            createdBy: 0
        });
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const onSaveProductSku = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const data = await SaveProductSku(formData);
            if (data.isSuccess === 200) {
                toast.success("Save Successfully");
                handleReset();
                setIsFormopen(false);
                setSkuId(0);
                fetchProductSkuByProductId();
            }
        } catch (error) {
            // toast.error("Please try again later.");
        }
        finally {
            setLoading(false);
        }
    };

    const onEditProductSku = (item) => {
        setSkuId(item?.skuId)
        setIsFormopen(true);
        setFormData({
            ...formData,
            shapeId: item?.shapeId,
            weightId: item?.weightId,
            buyPrice: item?.buyPrice,
            taxId: item?.taxId,
            salePrice: item?.salePrice,
            mrp: item?.mrp,
            skuId: item?.skuId,
            skucode: item?.skucode,
            productId: item?.productId,
            sizeTypeId: item?.sizeTypeId,
            colorId: item?.colorId,
            isActive: item?.isActive,
            createdBy: item?.buyPrice
        })
    }

    const onDeleteProductSkuById = async (id) => {
        const isConfirmed = window.confirm("Are you sure you want to delete this item?");

        if (!isConfirmed) {
            return;
        }
        const data = await DeleteProductSkuById(id);
        if (data.isSuccess === 1) {
            fetchProductSkuByProductId();
            setSelectedColor(SelectedColor);
            toast.success("Delete Successfully");
        }
    };

    const fetchProductSkuByProductId = useCallback(async () => {
        try {
            const data = await GetProductSkuByProductId(productId);
            if (data.isSuccess === 1) {
                setProductSkuByProductId(data?.data)
            }
        } catch (error) {
            setProductSkuByProductId([]);
        }
    }, [productId]);

    const GetTexType = async () => {
        try {
            const data = await getTexType();
            setTexType(data);
        } catch (error) {
            setTexType([]);
        }
    };

    const fetchSizeType = async () => {
        try {
            const data = await GetSizeType();
            if (data.isSuccess === 1) {
                setSizeType(data?.data)
            }
        } catch (error) {
            setSizeType([]);
        }
    };

    const fetchColorType = async () => {
        try {
            const data = await GetColorType();
            if (data.isSuccess === 1) {
                setColors(data?.data)
            }
        } catch (error) {
            setColors([]);
        }
    };

    const fetchShapeType = async () => {
        try {
            const data = await GetShapeType();
            if (data.isSuccess === 1) {
                setShapeType(data?.data)
            }
        } catch (error) {
            setShapeType([]);
        }
    };

    const fetchWeightType = async () => {
        try {
            const data = await GetWeightType();
            if (data.isSuccess === 1) {
                setWeightType(data?.data)
            }
        } catch (error) {
            setWeightType([]);
        }
    };

    useEffect(() => {
        GetTexType();
        fetchSizeType();
        fetchColorType();
        fetchShapeType();
        fetchWeightType();
    }, []);

    useEffect(() => {
        fetchProductSkuByProductId();
    }, [fetchProductSkuByProductId]);

    const handleFileChange = async (e) => {
        const files = e.target.files;

        // Check the file type and resize if it's an image (JPEG/PNG)
        if (files && files.length > 0) {
            for (let file of files) {
                if (file.type === 'image/jpeg' || file.type === 'image/png') {
                    const image = new Image();
                    image.src = URL.createObjectURL(file);

                    image.onload = async () => {

                        try {
                            // Resize the image if necessary
                            const resizedFile = await resizeImage(file, 640, 960);

                            // Add resized file to formData
                            setBulkImageFormData((prevState) => ({
                                ...prevState,
                                files: [...prevState.files, resizedFile], // Add to the files array
                            }));

                        } catch (err) {
                            toast.error("Error resizing the image.");
                        }
                    };
                } else {
                    toast.error("Only JPEG and PNG images are allowed.");
                }
            }
        }
    };

    const onBulkUploadImage = (id) => {
        setBulkPopupSkuId(true);
        setImageSkuId(id);
    }

    const uniqueSizeTypeNames = [
        ...new Set(productSkuByProductId.map(item => item.sizeTypeName))
    ];

    // Handle filter change
    const handleFilter = (event) => {
        const selected = event.target.value;
        setSelectedSize(selected);
        setSelectedColor('All');
        if (selected === 'All') {
            setFilteredData(productSkuByProductId);
        } else {
            const filtered = productSkuByProductId.filter(item => item.sizeTypeName === selected);
            setFilteredData(filtered);
        }
    };

    const uniqueColorNames = [
        ...new Set(productSkuByProductId.map(item => item.colorName))
    ];

    const handleFilterColor = (event) => {
        const selected = event.target.value;
        setSelectedColor(selected);
        // sessionStorage.setItem('SelectedColor', selected);
        setSelectedSize('All');

        if (selected === 'All') {
            setFilteredData(productSkuByProductId);
        } else {
            const filtered = productSkuByProductId.filter(item => item.colorName === selected);
            setFilteredData(filtered);
        }
    };

    useEffect(() => {
        setFilteredData(productSkuByProductId);
    }, [productSkuByProductId]);

    useEffect(() => {
        if (searchTerm) {
            const filtered = productSkuByProductId.filter(item =>
                item.sizeTypeName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                item.colorName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                item.salePrice.toString().includes(searchTerm)
            );
            setFilteredData(filtered);
        } else {
            setFilteredData(productSkuByProductId);
        }
    }, [searchTerm, productSkuByProductId]);

    const columns = [
        {
            name: 'SR.No',
            selector: (row, index) => index + 1,
            sortable: false,
            width: '80px',
        },
        {
            name: 'Size',
            selector: row => row.sizeTypeName,
            sortable: true,
            width: '150px',
        },
        ...(projectNo === "GAILEE"
            ? [
                {
                    name: 'Color',
                    selector: row => row.colorName,
                    sortable: true,
                    width: '150px',
                }
            ]
            : []
        ),
        ...(projectNo === "MUJems"
            ? [
                {
                    name: 'Shape',
                    selector: row => row.shape,
                    sortable: true,
                    width: '150px',
                },
                {
                    name: 'Weight',
                    selector: row => row.weight,
                    sortable: true,
                    width: '150px',
                }
            ]
            : []
        ),
        {
            name: 'Sale Price',
            selector: row => row.salePrice,
            sortable: true,
            width: '150px',
        },
        {
            name: 'MRP',
            selector: row => row.mrp,
            sortable: true,
            width: '150px',
        },
        {
            name: 'Upload Images',
            selector: row => (
                <div className='upload_productsku_image d-flex align-items-center gap-2'>
                    <span className='edit_icon_wepper' title='upload image' onClick={() => onBulkUploadImage(row.skuId)}>
                        {/* <img src="./images/image.svg" /> */}
                        <i className="fas fa-upload"></i>
                    </span>
                    {row?.productImageDtos?.length > 0 && (
                        <>
                            <span title='View' type="button" className="edit_icon_wepper" data-bs-toggle="modal" data-bs-target="#staticBackdrop">
                                <i className="fas fa-eye"></i>
                            </span>

                            <div className="modal fade image_model" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                                <div className="modal-dialog modal-dialog-centered">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                        </div>
                                        <div className="modal-body">
                                            <div className="row">
                                                {row?.productImageDtos?.map((item, i) => (
                                                    <div className="col-sm-2">
                                                        <img src={`${imageurl}${item?.imgPath}`} alt=""/>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            ),
            sortable: false,
            width: "120px"
        },
        {
            name: 'Action',
            cell: row => (
                <div className="d-flex" style={{ gap: "10px" }}>
                    <span title='Edit' className='edit_icon_wepper' onClick={() => onEditProductSku(row)}>
                        <svg id="Layer_1" viewBox="0 0 512 512" width="18" height="18" xmlns="http://www.w3.org/2000/svg">
                            <g transform="matrix(1,0,0,1,0,0)">
                                <path d="m41.3 512c-22.8 0-41.3-18.5-41.3-41.3 0-2.6.2-5.2.7-7.7l27.3-144.8c1.5-8.2 5.5-15.7 11.4-21.5l274-274c14.7-14.7 35.1-22.7 57.7-22.7 8.1 0 16.1 1 24 2.8 25.5 5.9 51.1 20.7 72.2 41.8s36 46.7 41.8 72.2c7.4 31.9.2 61.7-19.8 81.7l-274 274c-5.9 5.9-13.4 9.8-21.5 11.4l-144.8 27.4c-2.5.5-5.1.7-7.7.7zm51.8-93.1 72.9-13.8 182-182-59.1-59.1-182 182zm313.3-254.2 23.1-23.1c.2-5.4-3.8-21.8-20.6-38.5-10.1-10.2-22-17.4-32.4-19.8-1.8-.4-3.7-.7-5.5-.7h-.7l-23 23z" fill="#526484" />
                                <path d="m499.4 119.1c-5.4-23.7-19.4-47.6-39.1-67.4s-43.8-33.7-67.4-39.1c-28.5-6.6-54.9-.4-72.3 17.1l-274 274c-4.5 4.4-7.5 10.1-8.7 16.3l-27.4 144.9c-3.2 17 8 33.4 24.9 36.6 1.9.4 3.9.5 5.8.5s3.9-.2 5.8-.5l145-27.4c6.2-1.2 11.9-4.2 16.3-8.6l274-274c17.5-17.5 23.7-43.9 17.1-72.4zm-328.5 295.3-90.3 17 17-90.3 191.3-191.3 73.3 73.3zm267.2-267.2-31.7 31.7-73.2-73.3 31.7-31.7c1-1 5.6-2.3 14-.4 12.2 2.8 25.8 11 37.2 22.4 23.5 23.7 25.6 47.7 22 51.3z" fill="url(#gradient1)" />
                                <defs>
                                    <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
                                        <stop offset="0%" stopColor="#526484" />
                                        <stop offset="100%" stopColor="#0063ff" />
                                    </linearGradient>
                                </defs>
                            </g>
                        </svg>
                    </span>
                    <span title='Delete' className="delete_icon_weepr" onClick={() => onDeleteProductSkuById(row.skuId)}>
                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 24 24">
                            <path d="M 10 2 L 9 3 L 4 3 L 4 5 L 5 5 L 5 20 C 5 20.522222 5.1913289 21.05461 5.5683594 21.431641 C 5.9453899 21.808671 6.4777778 22 7 22 L 17 22 C 17.522222 22 18.05461 21.808671 18.431641 21.431641 C 18.808671 21.05461 19 20.522222 19 20 L 19 5 L 20 5 L 20 3 L 15 3 L 14 2 L 10 2 z M 7 5 L 17 5 L 17 20 L 7 20 L 7 5 z M 9 7 L 9 18 L 11 18 L 11 7 L 9 7 z M 13 7 L 13 18 L 15 18 L 15 7 L 13 7 z" fill="#FF0000"></path>
                        </svg>
                    </span>
                </div>
            ),
            sortable: false
        }
    ];


    return (
        <div>
            <Toaster position="top-right" />
            <div className="admin-page mt-3 d-sm-flex justify-content-between align-items-center">
                <div className="admin-heading" style={{ gap: "20px" }}>
                    <h4 className="mb-0">Product Sku</h4>
                </div>
                <div className="d-md-flex align-items-center justify-content-end" style={{ gap: "20px" }}>
                    <div className="search-container col-md-6">
                        <input
                            type="text"
                            placeholder="Search..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="form-control"
                        />
                    </div>
                    <div className="add_btn">
                        <button onClick={() => setIsFormopen(true)}>Add Product Sku</button>
                    </div>
                </div>
            </div>

            {bulkPopupSkuId &&
                <div className="bulk_image_popup">
                    <div className="mt-3 bulk_form_wrapper">
                        <div className="closebtn">
                            <button className="" onClick={bulkPopupClose} >
                                <svg clipRule="evenodd" fillRule="evenodd" width="25" height="25" imageRendering="optimizeQuality" shapeRendering="geometricPrecision" textRendering="geometricPrecision" viewBox="0 0 6.82666 6.82666" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink" >
                                    <g transform="matrix(1,0,0,1,0,0)">
                                        <g id="Layer_x0020_1">
                                            <rect fill="#ffffff00" height="6.827" rx="1.507" width="6.827" stroke="none" />
                                            <path d="m2.21002 1.41333-.79669.79669 1.20331 1.20331-1.20331 1.20331.79669.79669 1.20331-1.20331 1.20332 1.20331.79668-.79669-1.2033-1.20331 1.2033-1.20331-.79669-.79669-1.20331 1.2033z" fill="#ffffff" stroke="none" />
                                        </g>
                                    </g>
                                </svg>
                            </button>
                        </div>
                        <form onSubmit={onBulkUpload}>
                            <div className="form-group">
                                <label htmlFor="file" className="mb-1">Upload Sku Bulk Images{projectNo=== 'GAILEE' && (`(640*960)`) }</label>
                                <input
                                    type="file"
                                    className="form-control"
                                    id="file"
                                    name="file"
                                    multiple
                                    onChange={handleFileChange}
                                />
                            </div>
                            <div className="submit_btn mt-2">
                                <button type="submit" className="">
                                    Submit
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            }

            <div className='d-flex gap-4'>
                {uniqueSizeTypeNames?.length > 0 && (
                    <div className="d-flex filter_admin_size gap-3 align-items-center mt-4">
                        <label htmlFor="sizeFilter">Size: </label>
                        <div className='size_filter_detail'>
                            <select
                                id="sizeFilter"
                                className="form-select"
                                aria-label="Default select example"
                                value={selectedSize}
                                onChange={handleFilter}
                            >
                                <option value="All" selected>All</option>
                                {uniqueSizeTypeNames.map((item, i) => (
                                    <option key={i} value={item}>
                                        {item}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                )}
                {projectNo === "GAILEE" && (
                    uniqueColorNames?.length > 0 && (
                        <div className="d-flex filter_admin_size gap-3 align-items-center mt-4">
                            <label htmlFor="sizeFilter">Color: </label>
                            <div className='color_filter_detail'>
                                <select
                                    id="sizeFilter"
                                    className="form-select"
                                    aria-label="Default select example"
                                    value={selectedColor}
                                    onChange={handleFilterColor}
                                >
                                    <option value="All" selected>All</option>
                                    {uniqueColorNames.map((item, i) => (
                                        <option key={i} value={item}>
                                            {item}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    ))}
            </div>

            <div className="datatable mt-2">
                <DataTable
                    columns={columns}
                    data={filteredData}
                    progressPending={loading}
                    progressComponent={<p>Loading...</p>}
                    pagination
                    highlightOnHover
                />
            </div>

            <div id="entryformContainer" className={`adminform entryform ${isFormopen ? 'open' : ''}`}>
                <div className="closebtn">
                    <button className="" onClick={onClose} >
                        <svg clipRule="evenodd" fillRule="evenodd" height="30" imageRendering="optimizeQuality" shapeRendering="geometricPrecision" textRendering="geometricPrecision" viewBox="0 0 6.82666 6.82666" width="30" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink" >
                            <g transform="matrix(1,0,0,1,0,0)">
                                <g id="Layer_x0020_1">
                                    <rect fill="#ffffff00" height="6.827" rx="1.507" width="6.827" stroke="none" />
                                    <path d="m2.21002 1.41333-.79669.79669 1.20331 1.20331-1.20331 1.20331.79669.79669 1.20331-1.20331 1.20332 1.20331.79668-.79669-1.2033-1.20331 1.2033-1.20331-.79669-.79669-1.20331 1.2033z" fill="#fffffe" stroke="none" />
                                </g>
                            </g>
                        </svg>
                    </button>
                </div>
                <div className="enForm">
                    <div className="text-center form-heading">
                        <h4>Add Product Sku</h4>
                    </div>
                    <form onSubmit={onSaveProductSku}>
                        <div className="form-group">
                            <label htmlFor="sizeSelect">Product Size</label>
                            <select id="sizeTypeId" name="sizeTypeId" className="form-control" value={formData.sizeTypeId || ""} onChange={handleChange} required>
                                <option value="">Select a Size</option>
                                {Array.isArray(sizeType) && sizeType.length > 0 ? (
                                    sizeType.map((item) => (
                                        <option key={item?.sizeTypeId} value={item?.sizeTypeId}>
                                            {item?.name}
                                        </option>
                                    ))
                                ) : null}
                            </select>
                        </div>

                        {projectNo === "MUJems" && (
                            <>
                                <div className="form-group">
                                    <label htmlFor="colorSelect">Product Shape</label>
                                    <select id="shapeId" name="shapeId" className="form-control" value={formData.shapeId} onChange={handleChange} required>
                                        <option value="">Select a Shape</option>
                                        {Array.isArray(shapeType) && shapeType.length > 0 ? (
                                            shapeType.map((item) => (
                                                <option key={item?.shapeId} value={item?.shapeId}>
                                                    {item?.shape}
                                                </option>
                                            ))
                                        ) : null}
                                    </select>
                                </div>

                                <div className="form-group">
                                    <label htmlFor="colorSelect">Product Weight</label>
                                    <select id="weightId" name="weightId" className="form-control" value={formData.weightId} onChange={handleChange} required>
                                        <option value="">Select a Weight</option>
                                        {Array.isArray(weightType) && weightType.length > 0 ? (
                                            weightType.map((item) => (
                                                <option key={item?.weightId} value={item?.weightId}>
                                                    {item?.weight}
                                                </option>
                                            ))
                                        ) : null}
                                    </select>
                                </div>
                            </>
                        )}

                        {projectNo === "GAILEE" && (
                            <div className="form-group">
                                <label htmlFor="colorSelect">Product Color</label>
                                <select id="colorId" name="colorId" className="form-control" value={formData.colorId} onChange={handleChange} required>
                                    <option value="">Select a Color</option>
                                    {Array.isArray(sizeType) && sizeType.length > 0 ? (
                                        colors.map((item) => (
                                            <option key={item?.colorId} value={item?.colorId}>
                                                {item?.colorName}
                                            </option>
                                        ))
                                    ) : null}
                                </select>
                            </div>
                        )}

                        <div className="form-group">
                            <label htmlFor="exampleFormControlInput1">Buy Price</label>
                            <input type="text" className="form-control" id="buyPrice" name="buyPrice" placeholder="Buy Price" value={formData.buyPrice} onChange={handleChange} required />
                        </div>
                        <div className="form-group">
                            <label htmlFor="exampleFormControlInput1">Sale Price</label>
                            <input type="text" className="form-control" id="salePrice" name="salePrice" placeholder="Sale Price" value={formData.salePrice} onChange={handleChange} required />
                        </div>

                        <div className="form-group">
                            <label htmlFor="exampleFormControlInput1">Mrp</label>
                            <input type="text" className="form-control" id="mrp" name="mrp" placeholder="Mrp" value={formData.mrp} onChange={handleChange} required />
                        </div>

                        <div className="form-group">
                            <label htmlFor="exampleFormControlInput1">Sku code{`(Optional)`}</label>
                            <input type="text" className="form-control" id="skucode" name="skucode" placeholder="ex.:SKUSW" value={formData.skucode} onChange={handleChange} />
                        </div>

                        <div className="form-group">
                            <label htmlFor="taxId">TaxId</label>
                            <select id="taxId" name="taxId" className="form-control" value={formData.taxId || ""} onChange={handleChange} required>
                                <option value="">Select a TaxId</option>
                                {texType.map((textype) => (
                                    <option key={textype?.taxId} value={textype?.taxId}>
                                        {textype?.taxDisplay}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {/* <div className="form-group d-flex">
                            <div className="form-check">
                                <input type="checkbox" className="form-check-input" id="isActive" name="isActive" value={formData.isActive} onChange={handleChange} />
                            </div>
                            <label htmlFor="exampleFormControlInput1">isActive</label>
                        </div> */}

                        <div className="d-flex form-buttons" style={{ gap: "15px" }}>
                            <div className="submit-btn pt-2">
                                <button type="submit">{skuId ? 'Update' : 'Submit'}</button>
                            </div>
                            <div className="reset-btn pt-2">
                                <button className="" onClick={handleReset}>Reset</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default ProductSku;